import { render, staticRenderFns } from "./MenuStrikeButton.vue?vue&type=template&id=b5adaf88&"
import script from "./MenuStrikeButton.vue?vue&type=script&lang=ts&"
export * from "./MenuStrikeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports